export var getOptionCode = function getOptionCode(option) {
  var _option$code;

  return (_option$code = option === null || option === void 0 ? void 0 : option.code) !== null && _option$code !== void 0 ? _option$code : option.id;
};
export var getOptionName = function getOptionName(option) {
  var _option$name;

  return (_option$name = option === null || option === void 0 ? void 0 : option.name) !== null && _option$name !== void 0 ? _option$name : option.displayName;
};